module.exports = __webpack_public_path__ + "static/media/my-beep.b020b437.mp3";